import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

// types
import { IconSetIds } from "../../../common/components/Icon/IconMap";

// styles
import cx from "classnames";

// components
import Button from "../../../common/components/Forms/Button/Button";
import Icon from "../../../common/components/Icon/Icon";

interface IQuoteFrequencyControlProps {
    isDisabled?: boolean;
    setEditIcon?: IconSetIds;
    isFromDAP?: boolean;
    showWarning?: () => void;
    setWarningNextStepUrl?: (url: string) => void;
}

const QuoteControls: React.FC<IQuoteFrequencyControlProps> = ({
    isDisabled,
    setEditIcon,
    isFromDAP,
    showWarning,
    setWarningNextStepUrl
}) => {
    const history = useHistory();

    return (
        <div
            className={cx("layout-flex-row--justify-spaced", {
                ["fade-light"]: isDisabled
            })}>
            <Button
                component="button"
                variant="default"
                dataAttributes={{
                    ["data-ga_category"]: "quote-form",
                    ["data-ga_action"]: "edit-cover",
                    ["data-ga_label"]: "click"
                }}
                size="s"
                className="layout-flex-row--centered layout-hidden-full-desktop padding-horizontal-2xl"
                width="content"
                isDisabled={isDisabled}
                onClick={
                    !isDisabled &&
                    (() => {
                        const isQuoteWarningConfirm =
                            !!window.localStorage.getItem("quote-modified-warning") ||
                            false;
                        if (isFromDAP && !isQuoteWarningConfirm) {
                            setWarningNextStepUrl(`/products/edit`);
                            showWarning();
                            return;
                        }
                        history.push(`/products/edit`);
                    })
                }>
                <Icon id={setEditIcon || "EditCog"} size="2xl" className="space-s space-pre-l" />
                Edit quote
            </Button>
        </div>
    );
};

export default QuoteControls;
